export const issueCategoriesEnum = {
  'DATA_QUALITY.NO_ASSET': 'DATA_QUALITY.NO_ASSET',
  'DATA_QUALITY.NO_COMMUNICATION': 'DATA_QUALITY.NO_COMMUNICATION',
  'DATA_QUALITY.UNDECRYPTABLE_DATA': 'DATA_QUALITY.UNDECRYPTABLE_DATA',
  'MANUAL.NOT_ADOPTED': 'MANUAL.NOT_ADOPTED',
} as const

export type IssueCategoriesEnum = (typeof issueCategoriesEnum)[keyof typeof issueCategoriesEnum]

export type IssueCategories = IssueCategoriesEnum